import { screenSizes } from "../constants";
import { useAppSelector } from "../hooks/redux";

// Функции для экспорта данных в формате ПДФ
const base64ToArrayBuffer = (data) => {
  var bString = window.atob(data);
  var bLength = bString.length;
  var bytes = new Uint8Array(bLength);
  for (var i = 0; i < bLength; i++) {
    var ascii = bString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
};

export const base64toPDF = (name, content, setLoading) => {
  var bufferArray = base64ToArrayBuffer(content);
  var blobStore = new Blob([bufferArray], { type: "application/pdf" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blobStore);
    return;
  }
  var data = window.URL.createObjectURL(blobStore);
  var link = document.createElement("a");
  document.body.appendChild(link);
  link.href = data;
  link.download = name;
  link.click();
  window.URL.revokeObjectURL(data);
  link.remove();
  setLoading(false);
};

export const printBase64 = (content, setPrintLoading) => {
  var bufferArray = base64ToArrayBuffer(content);
  var blob = new Blob([bufferArray], { type: "application/pdf" }); //this make the magic
  var blobURL = URL.createObjectURL(blob);

  let iframe = document.createElement("iframe"); //load content in an iframe to print later
  document.body.appendChild(iframe);

  iframe.style.display = "none";
  iframe.src = blobURL;
  iframe.onload = function () {
    setTimeout(function () {
      iframe.focus();
      iframe.contentWindow.print();
    }, 1);
  };
  setPrintLoading(false);
};

// Функция для формирования query строки для фильтрации данных в таблице
export const getQueryString = (filtersRes) => {
  return `${
    "&" +
    Object.keys(filtersRes)
      .map((key) => `${key}=${filtersRes[key]}`)
      .join("&")
  }`;
};

export function removeEmptyFields(obj) {
  const result = { ...obj };
  
  for (const key in result) {
    if (result[key] === null || result[key] === undefined || result[key] === '') {
      delete result[key];
    }
  }
  
  return result;
}

export const getAddressString = (address, name) => {
  if (!address) return "";

  const parts = [];

  if (address.region) parts.push(`&${name}.Region=${address.region}`);
  if (address.area && address.area !== address.region) parts.push(`&${name}.Area=${address.area}`);
  if (address.city) parts.push(`&${name}.City=${address.city}`);
  if (address.town) parts.push(`&${name}.Town=${address.town}`);
  if (address.cityDistrict) parts.push(`&${name}.CityDistrict=${address.cityDistrict}`);
  if (address.cityArea) parts.push(`&${name}.CityArea=${address.cityArea}`);
  if (address.street) parts.push(`&${name}.Street=${address.street}`);
  if (address.building) parts.push(`&${name}.Building=${address.building}`);
  if (address.extension) parts.push(`&${name}.Extension=${address.extension}`);

  return parts.join("");
};

export const getSecurityFilterTable = (securityFilterTables) => {
  if (!securityFilterTables || securityFilterTables === -1) return "";
  return securityFilterTables;
};

export const getTableHieght = (currentScreenSize, documentPageFlag, minusHeightMax, minusHeightMin) => {

  if (documentPageFlag) {
    return {
        max:
          currentScreenSize.height < screenSizes.defaultDesktop.height
            ? "46vh"
            : "53vh",
        min:
          currentScreenSize.height < screenSizes.defaultDesktop.height
            ? "50vh"
            : "53vh",
      };
  } else {
    return {
      max: `calc(100vh - ${minusHeightMax})`,
      min: `calc(100vh - ${minusHeightMin})`
    };
  }
};
